import { fmtMoney } from "../../parsers/xmlParser";
import { KOD_TECHULAT_SHICHVA, SUG_ITRA_LETKUFA, SUG_HAFRASHA } from "../../utils/fieldMaps";

export default function BreakdownTab({ fund, cs }) {
  return (
    <>
      <div style={{ marginTop: 8 }}>
        <div style={{ fontWeight: 700, fontSize: 13, color: cs.accent, marginBottom: 12 }}>פירוט נתוני שכבות ותקופות</div>
        <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 8 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, textAlign: "right" }}>
            <thead>
              <tr style={{ background: "#f8fafc", borderBottom: `2px solid ${cs.border}`, color: cs.dark }}>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>תאריך נכונות</th>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>מעסיק / גורם</th>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>שכבה / חוק</th>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>סוג הפרשה</th>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>סיווג</th>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>תקרת הפקדה</th>
                <th style={{ padding: "10px 12px", fontWeight: 700 }}>סכום</th>
              </tr>
            </thead>
            <tbody>
              {fund.yitrot?.perPeriod?.length > 0 ? fund.yitrot.perPeriod.map((p, i) => {
                const sugHafrasha = SUG_HAFRASHA[p.rekiv] || p.rekiv || "לא ידוע";
                const shichva = KOD_TECHULAT_SHICHVA[p.shichva] || p.shichva || "—";
                const sugItraLabel = SUG_ITRA_LETKUFA[p.sugItra] || p.sugItra || "—";
                return (
                  <tr key={i} style={{ borderBottom: "1px solid #e2e8f0", background: i % 2 === 0 ? "white" : "#f8fafc" }}>
                    <td style={{ padding: "9px 12px" }}>{fund.yitrot.date}</td>
                    <td style={{ padding: "9px 12px" }}>{p.maasikName || "—"}</td>
                    <td style={{ padding: "9px 12px" }}>{shichva}</td>
                    <td style={{ padding: "9px 12px", fontWeight: 600 }}>{sugHafrasha}</td>
                    <td style={{ padding: "9px 12px" }}>{sugItraLabel}</td>
                    <td style={{ padding: "9px 12px" }}>{{ "1": "עד התקרה", "2": "מעל התקרה" }[p.tikratHafkada] || "—"}</td>
                    <td style={{ padding: "9px 12px", fontWeight: 700, color: cs.accent }}>{fmtMoney(p.amount)}</td>
                  </tr>
                );
              }) : (
                <tr><td colSpan="7" style={{ padding: 12, textAlign: "center", color: "#64748b" }}>אין נתוני שכבות להצגה</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
